import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ShelfProvider } from "./context/ShelfContext";
import { ProductProvider } from "./context/ProductContext";
import { CartProvider } from "./context/CartContext";
import { CustomerProvider } from "./context/CustomerContext";
import { SupplierProvider } from "./context/SupplierContext";
import { PurchaseInvoiceProvider } from "./context/PurchaseInvoiceContext";
import { SalesInvoiceProvider } from "./context/SalesInvoiceContext";
import { BarcodeEntryProvider } from "./context/BarcodeEntryContext";
import { ReceiptVoucherProvider } from "./context/ReceiptVoucherContext";
import { PaymentVoucherProvider } from "./context/PaymentVoucherContext";
import { ExpenseInvoiceProvider } from "./context/ExpenseInvoiceContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <CustomerProvider>
        <SupplierProvider>
          <PurchaseInvoiceProvider>
            <SalesInvoiceProvider>
              <ReceiptVoucherProvider>
                <PaymentVoucherProvider>
                  <ExpenseInvoiceProvider>
                    <BarcodeEntryProvider>
                      <CartProvider>
                        <ProductProvider>
                          <ShelfProvider>
                            <BrowserRouter>
                              <App />
                            </BrowserRouter>
                          </ShelfProvider>
                        </ProductProvider>
                      </CartProvider>
                    </BarcodeEntryProvider>
                  </ExpenseInvoiceProvider>
                </PaymentVoucherProvider>
              </ReceiptVoucherProvider>
            </SalesInvoiceProvider>
          </PurchaseInvoiceProvider>
        </SupplierProvider>
      </CustomerProvider>
    </AuthProvider>
  </React.StrictMode>
);
